import { LoadPatientInfo } from 'domain/usecases/patient/load-patient-info'
import { PatientRepository } from 'repository/interfaces/patient-repository'

export class RemoteLoadPatientInfo implements LoadPatientInfo {
  private readonly patientRepository: PatientRepository

  constructor(patientRepository: PatientRepository) {
    this.patientRepository = patientRepository
  }

  load(
    params?: LoadPatientInfo.Params,
    patient_id?: number
  ): Promise<LoadPatientInfo.Model> {
    return this.patientRepository.loadPatientInfo(params, patient_id)
  }
}

export type LoadPatientInfoModel = LoadPatientInfo.Model
